import React from "react"
import ScrollButton from "../scrollButton"

export const HeadingWithButton = ({ heading, button, KlayvioFormId }: any) => {
    const handleShowModal = () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', KlayvioFormId]);
    };
    return (
        <div className="relative w-full" >
            <div className=" py-[58px] desktop-padding relative z-10" >
                <h2 className="h2  text-center " >{heading}</h2>
                <div className="mt-[32px] flex items-center justify-center " >
                    <ScrollButton
                        variant="default"
                        size="fixed"
                        className="bg-primary text-secondary !font-bold "
                        name={button}
                        onClick={handleShowModal}
                    ></ScrollButton>
                </div>
            </div>
        </div>
    )
}